<template>
    <div class="card-data ranking">
        <!-- <div class="card-title">
            <h5>{{title}}</h5>
        </div> -->
        <div class="revenue-table" v-if="loader">
            <!-- <div class="table-row head">
                <p class="name">Revenue por contenidos</p>
                <p class="number">${{thousandseparatos(totalRevenue)}}</p>
            </div> -->
            <div class="table-row head">
                <p class="name">Sucursal</p>
                <p class="number">Revenue</p>
            </div>
            <div class="table-row" v-for="(item,key) in data" :key="key">
                <p class="name">{{item.name}}</p>
                <p class="number">${{thousandseparatos(item.revenue)}}</p>
            </div>
        </div>

        <div v-else>
            <Loader/>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
    name: 'RevenueClusterCard',
    components: {
        Loader
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        loader: {
            type: Boolean,
            default: false
        },
        totalRevenue: {
            type: String,
            default: "",
            required: true
        }
    },
    methods: {
        thousandseparatos: function(num){
            try {
                let num_parts = []
                num = parseInt(num)
                if (num > 999999){
                  num = ((num / 1000000).toFixed(1))
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                  num_parts = num_parts+" MM"
                }else{
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                }

                return num_parts
            } catch (error) {
                return error
            }
        },
    },
}
</script>

<style lang="sass">
.revenue-table
    display: block
    grid-column-start: 2
    grid-column-end: 3
    font-family: $title-font
    font-size: 14px
    color: #302f2f
    margin-bottom: $sm
    text-align: left
    box-sizing: border-box
    maring-top: $sm
    width: calc(100% - 8px) //fix a la mala, deberia ser un padding
    .table-row
        display: flex
        flex-direction: row
        flex-grow: 0
        flex-wrap: wrap
        width: 100%
        font-family: $body-font
        @include tablet-portrait

        .name
            flex-grow: 1
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            width: 50%
            @include tablet-landscape
                font-size: 12px
        .number
            flex-grow: 1
            text-align: right
            width: 50%
            @include tablet-landscape
                font-size: 12px
        &.head
            font-family: $title-font
            margin-bottom: $xs
            font-weight: bold
            .number
                text-align: right
</style>